import { Log } from '@lightningjs/sdk'
import axios from 'axios'
import { Channel } from '../../app-api-config'
import { fetchData, getFetchUrl } from '../../models/data-service'
import { parseSubCategories, parseSubChannels } from '../../parser'
import { ItemNode } from "./ItemNode"

import RowList from './row-model'

export type RowListInfo = {
  rowList: RowList
  rowIndex: number
  rowPage: number
}

export class GridModel {
  limit: number
  count!: number
  categoryUrl = ''
  categoryList: RowListInfo[] = []
  type = ''
  url = ''
  channelInfo!: Channel | ItemNode | undefined
  isMlp:boolean;

  constructor(channelInfo: Channel | ItemNode, isMlp?: boolean) {
    this.channelInfo = channelInfo
    this.limit = 6 // prefech rows to be fetched
    this.url = this.channelInfo.url
    this.isMlp = isMlp || false
  }

  fetchInitialRows() {
    return new Promise((resolve, reject) => {
      if (this.categoryList.length > 0) {
        this.fetchPage(0).then((status) => {
          resolve(status)
        })
      } else {
        fetchData(getFetchUrl(this.url)).then((response: any) => {
          Log.debug('GridModel: fetchInitialRows: ', response.data)
          this.categoryList = this.setupFetchPageList(response.data)
          Log.debug('GridModel: categoryList: ', this.categoryList)
          this.fetchPage(0).then((status) => {
            resolve(status)
          })
        })
      }
    })
  }

  setupFetchPageList(data: any): RowListInfo[] {
    let list: RowListInfo[]
    if (this.isMlp) {
      list = parseSubChannels(data).map(
        (_rowList: RowList, index: number): RowListInfo => {
          const listInfo: RowListInfo = {
            rowList: _rowList,
            rowIndex: index,
            rowPage: Math.floor(index / this.limit),
          }
          return listInfo
        },
      )
    } else {
      list = parseSubCategories(data).map(
        (_rowList: RowList, index: number): RowListInfo => {
          const listInfo: RowListInfo = {
            rowList: _rowList,
            rowIndex: index,
            rowPage: Math.floor(index / this.limit),
          }
          return listInfo
        },
      )
    }
    this.count = list.length
    return list
  }

  add(rowList: RowList, index = 0) {
    const rowListInfo: RowListInfo = {
      rowIndex: -1,
      rowList: rowList,
      rowPage: -1
    }
    if (this.categoryList.length == 0) {
      this.categoryList.push(rowListInfo)
    } else {
      this.categoryList.splice(index, 0, rowListInfo)
    }
    this._updateIndexPageData()
  }

  remove(index = -1) {
    let removeIndex = this.categoryList.length - 1
    if (index >= 0 && index < this.categoryList.length) { //update to allow the 0 index seems that while removing the queue where queue can be the first row.
      removeIndex = index
      this.categoryList.splice(removeIndex, 1)
      this._updateIndexPageData()
    } else {
      Log.error('GridModel: Failed to remove rowList, index out of bound')
    }
  }

  update(rowList: RowList, index = 0) {
    // const rowListInfo: RowListInfo = {
    //   rowIndex: -1,
    //   rowList: rowList,
    //   rowPage: -1
    // }
    // this.categoryList.splice(index, 1, rowListInfo)
    this.categoryList[index].rowList = rowList
    this._updateIndexPageData()
  }

  getRowAtIndex(index = 0): RowListInfo | null {
    if (this.categoryList.length > 0 && index >= 0 && index < this.categoryList.length) {
      return this.categoryList[index]!
    }
    return null
  }

  _updateIndexPageData() {
    this.categoryList.map((_rowList: RowListInfo, index: number) => {
      _rowList.rowIndex = index,
        _rowList.rowPage = Math.floor(index / this.limit)
    })
    this.count = this.categoryList.length
  }

  fetchPage(pgNo: number) {
    return new Promise((resolve) => {
      const stIndx = pgNo * this.limit
      let endIndx = stIndx + this.limit
      if (endIndx > this.categoryList.length) {
        endIndx = this.categoryList.length
      }
      const fetchArrayEndpoint = []
      for (let i = stIndx; i < endIndx; i++) {
        const item: RowListInfo = this.categoryList[i]!
        fetchArrayEndpoint.push(item)
      }

      Promise.all(fetchArrayEndpoint.map((fetchItem) => fetchItem.rowList.fetchMoreVideos(0)))
        .then(
          axios.spread((...allData) => {
            resolve(true)
          }),
        )
        .catch((error) => {
          Log.info(error)
        })
    })
  }

  destroy() {
    if (this.categoryList.length >= 0) {
      /*this.categoryList.map((_rowListInfo) => {
        _rowListInfo.rowList.destroy()
      })*/
      this.categoryList = []
      this.channelInfo = undefined
    }
  }
}
